module.exports = __webpack_public_path__ + "img/huangwenze.f1ca4410.png";